export const pathnames = {
  root: '/',
  verify_email: '/verify-email',
  account_type: '/account-type',
  ecp_status: '/ecp-status',
  background_info: '/background-info',
  complete_application: '/complete-application',
  thank_you: '/thank-you',
  contact_info: '/contact-info',
  business_info: '/business-info',
  business_representatives: '/business-info/representatives',
  business_owners: '/business-info/owners',
  business_docs: '/business-info/docs',
  beneficial_owner: '/beneficial-owner',
  beneficial_owner_contact_info: '/beneficial-owner/contact-info',
  beneficial_owner_verification: '/beneficial-owner/verification',
}

export const SHARED_ROUTES = {
  [pathnames.root]: {
    'name': 'Home',
    'next': pathnames.verify_email,
  },
  [pathnames.verify_email]: {
    'name': 'Verify Email',
    'next': pathnames.account_type,
  },
  [pathnames.account_type]: {
    'name': 'Account Type',
    'next': pathnames.contact_info,
  },
  [pathnames.ecp_status]: {
    'name': 'ECP Status',
    'next': pathnames.complete_application,
  },
  [pathnames.complete_application]: {
    'name': 'Complete Application',
    'next': pathnames.thank_you,
  },
  [pathnames.thank_you]: {
    'name': 'Thank You',
    'next': pathnames.root,
  },
}

export const CONTACT_INFO_ROUTES = {
  [pathnames.contact_info]: {
    'name': 'Contact Information',
    'next': pathnames.ecp_status,
  },
}

export const BUSINESS_INFO_ROUTES = {
  [pathnames.business_info]: {
    'name': 'Business Information',
    'next': pathnames.business_representatives,
  },
  [pathnames.business_representatives]: {
    'name': 'Authorized Representatives',
    'next': pathnames.business_owners,
  },
  [pathnames.business_owners]: {
    'name': 'Beneficial Owners',
    'next': pathnames.business_docs,
  },
  [pathnames.business_docs]: {
    'name': 'Supporting Documents',
    'next': pathnames.background_info,
  },
  [pathnames.background_info]: {
    'name': 'Background Information',
    'next': pathnames.ecp_status,
  },
}

export const BENEFICIAL_OWNER_ROUTES = {
  [pathnames.beneficial_owner]: {
    'name': 'Beneficial Owner Country',
    'next': pathnames.beneficial_owner_verification,
  },
  [pathnames.beneficial_owner_contact_info]: {
    'name': 'Beneficial Owner Info',
    'next': pathnames.beneficial_owner_verification,
  },
  [pathnames.beneficial_owner_verification]: {
    'name': 'Beneficial Owner Verification',
    'next': pathnames.thank_you,
  },
}

export const ROUTES = {
  ...SHARED_ROUTES,
  ...CONTACT_INFO_ROUTES,
  ...BUSINESS_INFO_ROUTES,
  ...BENEFICIAL_OWNER_ROUTES,
}
